import { IMediaItem, IMention, IPostCreatedBy } from '_interfaces/types/post.types';
import { IPostCommentStatus } from '_interfaces/types/postComment.types';
import { DocumentData } from 'firebase/firestore';
import { IGetActivityFeedHashtag } from 'redux-store/api/activity-feed/hashtags.types';

export class IPostComment {
  static kId = 'id';
  static kCompanyId = 'companyId';
  static kCreatedAt = 'createdAt';
  static kCreatedBy = 'createdBy';
  static kProjectId = 'projectId';
  static kItemId = 'itemId';
  static kIsDeleted = 'isDeleted';
  static kIsEdited = 'isEdited';
  static kLikes = 'likes';
  static kMessage = 'message';
  static kPostId = 'postId';
  static kReplyCount = 'replyCount';
  static kMentions = 'mentions';
  static kHashtags = 'hashtags';
  static kUploads = 'uploads';
  static kMedia = 'media';
  static kStatus = 'status';
  static kParentPath = 'parentPath';
  static kReplyToCommentId = 'replyToCommentId';
  static kRootCommentId = 'rootCommentId';

  constructor(
    public readonly id: string | undefined,
    public readonly companyId: string,
    public readonly createdAt: Date,
    public readonly createdBy: IPostCreatedBy,
    public readonly projectId: string,
    public readonly itemId: string,
    public readonly isDeleted: boolean,
    public readonly isEdited: boolean,
    public readonly likes: string[],
    public readonly message: string,
    public readonly postId: string,
    public readonly replyCount: number,
    public readonly mentions: IMention[],
    public readonly hashtags: IGetActivityFeedHashtag[],
    public readonly uploads: string[],
    public readonly media: IMediaItem[],
    public readonly status: IPostCommentStatus,
    public readonly parentPath: string,
    public readonly replyToCommentId: string | null = null,
    public readonly rootCommentId: string | null = null
  ) {}

  static empty() {
    return new IPostComment(
      '',
      '',
      new Date(),
      {
        userId: '',
        displayName: '',
        avatarUrl: '',
      },
      '',
      '',
      false,
      false,
      [],
      '',
      '',
      0,
      [],
      [],
      [],
      [],
      IPostCommentStatus.DRAFT,
      '',
      null,
      null
    );
  }

  static fromDocumentData(data: DocumentData) {
    return new IPostComment(
      data[IPostComment.kId],
      data[IPostComment.kCompanyId],
      data[IPostComment.kCreatedAt]?.toDate?.() || data[IPostComment.kCreatedAt],
      data[IPostComment.kCreatedBy],
      data[IPostComment.kProjectId],
      data[IPostComment.kItemId],
      data[IPostComment.kIsDeleted],
      data[IPostComment.kIsEdited],
      data[IPostComment.kLikes],
      data[IPostComment.kMessage],
      data[IPostComment.kPostId],
      data[IPostComment.kReplyCount],
      data[IPostComment.kMentions],
      data[IPostComment.kHashtags],
      data[IPostComment.kUploads],
      data[IPostComment.kMedia] || [],
      data[IPostComment.kStatus],
      data[IPostComment.kParentPath],
      data[IPostComment.kReplyToCommentId] || null,
      data[IPostComment.kRootCommentId] || null
    );
  }
}
